<template>
  <div>
    <el-col :xs="24" :sm="18" :md="18" :lg="18" :xl="18" class="main-container">
      <el-col v-if="steps === 1" :span="24" class="broker-list-container">
        <component :is="currentComponent" :data="ruleForm" :session_token_url="session_token_url" @logout="HandleLogout()"></component>
      </el-col>

      <el-col v-else :span="24" class="broker-list-container">
        <el-col :xs="24" :sm="24" :md="18" :lg="14" :xl="14" class="form-container">
          <el-col :span="24" class="card-header" style="text-align: center; padding-bottom: 40px;">
            <a href="https://www.smartcharts.net/" class="smartchart-logo">
              <object data="https://login.smartcharts.xyz/img/logo.svg" type="image/svg+xml"></object>
            </a>
          </el-col>

          <el-form ref="ruleForm" :model="ruleForm" :rules="rules" :label-position="position" label-width="120px">
            <el-form-item label="Email" prop="email" required>
              <el-input v-model="ruleForm.email" size="medium" clearable></el-input>
            </el-form-item>

            <el-form-item label="Password" prop="pass" required>
              <el-input
              size="medium"
                :type="passwordVisible ? 'text' : 'password'"
                v-model="ruleForm.pass"
                autocomplete="off"

              >
                <template slot="suffix">
                
                  <i
                    :class="passwordVisible ? 'el-icon-view' : 'el-icon-view'"
                    @click="togglePasswordVisibility"
                    style="cursor: pointer; margin-right: 10px; margin-top:13px;"
                  ></i>
                </template>
              </el-input>
            </el-form-item>

            <el-form-item>
              <el-checkbox v-model="rememberPassword">Remember Password</el-checkbox>
              <div data-v-0eec90be="" class="col"><a data-v-0eec90be="" href="/" class="form__forgot-password" data-msgid="Forgot Password?" data-current-language="en_GB">Forgot Password?</a></div>
            </el-form-item>

            
          </el-form>

           <el-col :span="24" class="card-footer">

              <el-col :span="12" style="text-align: left;">
                <el-dropdown>
                  <el-button type="primary">
                    <div v-if="active_lang === 'en'" class="drop-down-main">
                      <img src="https://login.smartcharts.xyz/img/flags/4x3/gb.svg" class="flag" />British English
                    </div>
                    <div v-else class="drop-down-main">
                      <img src="https://login.smartcharts.xyz/img/flags/4x3/tr.svg" class="flag" />Türk
                    </div>
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                      <img src="https://login.smartcharts.xyz/img/flags/4x3/gb.svg" class="flag" />British English
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <img src="https://login.smartcharts.xyz/img/flags/4x3/tr.svg" class="flag" />Türk
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </el-col>

              <el-col :span="12" style="text-align: right;">
                <el-button size="large" :loading="loading" @click="handleLogin('ruleForm')" type="success">LOGIN</el-button>
              </el-col>
            
          </el-col>
        </el-col>
      </el-col>
    </el-col>
  </div>
</template>

<script>
import DataComponent from "./DataComponent.vue";

export default {
  name: "MainContent",
  components: {
    DataComponent,
  },
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please input the password'));
      } else {
        if (this.ruleForm.checkPass !== '') {
          this.$refs.ruleForm.validateField('checkPass');
        }
        callback();
      }
    };

    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please input the password again'));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error("Passwords don't match!"));
      } else {
        callback();
      }
    };

    return {
      steps: 0,
      go_to_smartcharts: process.env.VUE_APP_GO_TO_SMARTCHARTS,
      position: 'right',
      passwordVisible: false,
      isMobile: false,
      loading: false,
      currentComponent: null,
      session_token_url: '',
      go_to_app_url: '',
      active_lang: 'en',
      rememberPassword: false,
      ruleForm: {
        email: '',
        pass: '',
        checkPass: '',
      },
      rules: {
        email: [{
          type: 'email',
          required: true,
          message: 'Incorrect Email',
          trigger: 'change',
        }],
        pass: [{
          validator: validatePass,
          trigger: 'blur',
        }],
        checkPass: [{
          validator: validatePass2,
          trigger: 'blur',
        }],
      }
    };
  },
  mounted() {
    
    if (this.$cookies.get('logout') === true) {
      localStorage.setItem('logout', false);
      sessionStorage.clear();
      localStorage.clear();
      const allCookies = this.$cookies.keys();
        allCookies.forEach((cookie) => {
            this.$cookies.remove(cookie);
        });
      
      this.steps = 0;
      this.currentComponent = null;
    }

    if (this.$cookies.get('web_session_id')) {

      this.$router.push('/manage');
    }

    this.updateSize();
    window.addEventListener('resize', this.updateSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateSize);
  },
  methods: {
    togglePasswordVisibility() {
      this.passwordVisible = !this.passwordVisible;
    },
    updateSize() {
      this.isMobile = window.innerWidth <= 767;
      this.position = this.isMobile ? 'top' : 'right';
    },
    goToCharts() {
      // const token = localStorage.getItem('token');
      const token = this.$cookies.get('token')
      // const sessionTokenUrl = encodeURIComponent(localStorage.getItem('session_token_url'));
      const fullUrl = this.session_token_url

      const baseUrl = fullUrl.split('?')[0];
      const encodedBaseUrl = encodeURIComponent(baseUrl);
      console.log(baseUrl);
      let url = ''
      if(localStorage.getItem('go_to_app_url')) {
        let app_url = localStorage.getItem('go_to_app_url')
        url = app_url + '/?token=' + token + '&session_token_url=' + encodedBaseUrl;
      }

      window.location.href = url;
      // window.location.href = `https://sc2-uat.fxbluelabs.com/?token=${token}&session_token_url=${sessionTokenUrl}`;
    },
    handleLogin(formName) {
      this.loading = true;
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          this.loading = false;
          return;
        }

      const path = this.$route.path; // "/smartchart/register"
      const segments = this.$route.path.split('/'); // ["", "smartchart", "register"]
      const base = window.location.origin; // "http://localhost:8081"
      const query = this.$route.query; // { b: "smartcharts" }

      // Extract subdomain (if present)
      const hostnameParts = window.location.hostname.split('.');
      let subdomain = null;

      // Example: smartchart.localhost or smartchart.example.com
      if (hostnameParts.length > 2) {
        subdomain = hostnameParts[0]; // "smartchart"
      } else if (hostnameParts.length === 2 && hostnameParts[0] !== 'localhost') {
        subdomain = hostnameParts[0]; // "smartchart" (when not localhost)
      }
    
      console.log('Subdomain:', subdomain);
      console.log('Base URL:', base);
      console.log('Full path:', path);
      console.log('First segment:', segments[1]); // "smartchart"
      console.log('Second segment:', segments[2]); // "register"
      console.log('Query parameter b:', query.b); // "smartcharts"

      let my_account_instance = ''
      if(subdomain) {
        my_account_instance = subdomain
      } else {
        my_account_instance = 'smartcharts'
      }
      

        const axios = require('axios');
        const data = {
          email: this.ruleForm.email,
          password: this.ruleForm.pass,
          myaccount_instance: my_account_instance
        };

        axios.post(process.env.VUE_APP_API_URL + "/v1/login", data, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            withCredentials: true,
          }
        }).then(response => {
          const user = response.data;
          this.session_token_url = user.session_token_url
          console.log(user,'res')

          let go_to_app_url = user.go_to_app_url;

          if (!go_to_app_url && user.authenticator) {
            go_to_app_url = user.authenticator.login_page_url;
          }

          this.go_to_app_url = go_to_app_url;
          localStorage.setItem('go_to_app_url', go_to_app_url);
          
          this.loading = false;
          // localStorage.setItem('token', user.token);
          this.$cookies.set('token',user.token);
          if (!user.user.selected_trading_account) {
            this.$router.push('/manage');
            this.$cookies.set('account_id',user.account_id);
            this.$cookies.set('cf_id', user.user.id);
            this.$cookies.set('web_session_id', user.web_session_id);
            this.$cookies.set('session_token_url', user.session_token_url);
            // localStorage.setItem('account_id', user.account_id);
            // localStorage.setItem('cf_id', user.user.id);
            // localStorage.setItem('web_session_id', user.web_session_id);
            // localStorage.setItem('session_token_url', user.session_token_url);
          } else {
            
            if (!this.$cookies.get('web_session_id')) {
              this.goToCharts();
            }

            this.$cookies.set('account_id',user.account_id);
            this.$cookies.set('cf_id', user.user.id);
            this.$cookies.set('web_session_id', user.web_session_id);
            this.$cookies.set('session_token_url', user.session_token_url);
          }

          
          

          
          
          console.log('login:', user.web_session_id);
        }).catch(error => {
          console.error(error);
          this.$notify.error({
            title: 'Error',
            message: error.response.data.message,
            // duration: 0
          });
          this.loading = false;
        });
      });
    },
    HandleLogout() {
      sessionStorage.clear();
      this.steps = 0;
      this.currentComponent = null;
      this.$router.push('/login');
    }
  }
};
</script>

<style scoped>
.main-container {
  float: none !important;
  margin: 0 auto !important;
  color: #ffffff !important;
  padding-top: 10vh;
}

.broker-list-wrapper {
  text-align: left;
}

.broker-list-wrapper h2 {
  font-weight: 300;
  font-size: 22px;
  margin-top: 40px;
  margin-bottom: 20px;
}

.broker-list-item {
  /* background-color: #3c4f6d; */
  transition: box-shadow 0.3s ease;
  background: linear-gradient(to right, #3f4f75, #3f3b5e);
  padding: 20px;
  display: flex;
  border-radius: 5px;
  height: 30px;
}

.logo_container img {
  /* width: 60px; */
  margin-left: 40px;
  width: auto;
  height: 30px;
}

.logo_container {}

.part-2 p,
.part-3 p,
.part-divider p {
  margin-block-start: 0px !important;
  margin-block-end: 0px !important;
  padding-top: 5px;
}

.part-2 p {
  color: #ffffff80;
}

.part-2 p strong {
  color: #ffffff;
}

.part-divider {
  text-align: center;
  color: #ffffff3d;
}

.broker-list-item.active {
  box-shadow: inset 0px 0px 0px 1px #93ca85;
}

.item-icon {
  transform: rotate(180deg) !important;
  color: #ffffff80;
  font-size: 20px;
  margin-left: 20px;
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  float: left;
  margin-top: 10px;
  margin-right: 5px;
}

.green {
  background-color: #93ca85;
}

.yellow {
  background-color: #e2ca5d;
}

.broker-list-item {
  margin-bottom: 10px;
}

.part-4 {
  float: right;
  text-align: center;

}

.broker-list-item:hover {
  box-shadow: inset 0px 0px 0px 1px #93ca85;
}

.item-btn {
  float: right;
  text-align: center;
  box-shadow: inset 0px 0px 0px 1px #93ca85;
  padding: 5px 40px;
  border-radius: 3px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.item-btn:hover {
  background-color: #93ca855c;
  transition: background-color 0.3s ease;
}

.darkBlue {
  background: #283a5d !important;
  width: 13%;
  margin-right: 5px;
  display: inline-block;
  box-shadow: inset 0px 0px 0px 1px #93ca85;
}

.available-types-title {
  text-align: center;
  color: #ffffffb3;
}

.available-icon-true {
  border-radius: 50%;
  /* background-color: #93ca85; */
  background-color: #5a954b;
  padding: 3px;
}

.available-icon-false {
  border-radius: 50%;
  /* background-color: #ea7374; */
  background-color: #e44f51;
  font-weight: bold;
  padding: 3px;
}

.item-btn.btn-apply {
  padding: 5px 24px;
}

.available-item-check-container {
  border-right: 1px solid #ffffff3d;
  margin-top: 5px;
}

.available-item-check-container.end {
  border-right: none !important;
}

.page-subtitle {
  color: #adc0ff;
  font-size: 20px;
}

.logo-icon-container {
  margin-left: -10px;
  display: flex;
  align-items: center;
  align-content: center;
  margin-top: -5px;
}

.available-broker-wrapper {
  padding-bottom: 10vh;
}

.available-broker-wrapper h2 {
  margin-bottom: 0px !important;
}

.broker-item-list {
  box-shadow: 1px 2px 3px #00000021;

}

.steps {
  height: 5px;
  border-radius: 10px;
  background-color: transparent;
  border: 1px solid #ffffff59;
  margin-right: 5px;
  width: 32% !important;
}

.green_ {
  background-color: #a4f14a;
  color: #a4f14a;
}

.red_ {
  background-color: #ff6c6c;
  color: #ff6c6c;
}

.yellow_ {

  background-color: #ffd077;
  color: #ffd077;
}

.green_text {
  color: #a4f14a;
}
</style>
